import React from 'react';
import _ from 'lodash';

import {
  AppSettings_AssignedPermissionsTabDocument,
  AppSettings_AssignedPermissionsTab_UserDetailSectionDocument,
  useAssignRoleModalQuery,
  useAssignRoleMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  roleTemplateId2AssignedStoreIds: _.Dictionary<string[]>;
}

export function useQuery(siteUserId: string) {
  const tuple = useAssignRoleModalQuery({
    variables: {
      siteUserId
    }
  });

  return React.useMemo(
    () => {
      const roleTemplateId2Assignments = _.groupBy(
        tuple.data?.siteUser?.assignedRoles ?? [],
        role => role.roleTemplate.id
      );

      const roleTemplateId2AssignedStoreIds = _.mapValues(
        roleTemplateId2Assignments,
        assignments => _.compact(_.map(assignments, assignment => assignment.store?.id ?? ''))
      );

      const data: IData = {
        roleTemplateId2AssignedStoreIds
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useAssignRole(siteUserId: string) {
  const [fnMutate, tuple] = useAssignRoleMutation({
    refetchQueries: [
      {
        query: AppSettings_AssignedPermissionsTabDocument,
        variables: {}
      },
      {
        query: AppSettings_AssignedPermissionsTab_UserDetailSectionDocument,
        variables: { siteUserId }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (formState: types.IFormState) => {
      if (formState.roleTemplate) {
        fnMutate({
          variables: {
            input: {
              siteUserId,
              userRoleTemplateId: formState.roleTemplate.id,
              storeIds: !_.isEmpty(formState.stores) ? _.map(formState.stores, s => s.id) : null
            }
          }
        });

      } else {
        alert("Select a role");
      }
    },
    [
      fnMutate,
      siteUserId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
